import { useMutation, useQueryClient } from '@tanstack/react-query';

import { QUERY_KEYS } from 'api/constants';
import { resolve } from 'api/resolve';
import { getResultSetEntry } from 'state/grids/getResultSetEntry';
import { GRID_STORE } from 'state/grids/gridState';
import { SNACKBAR_STORE } from 'state/snackbar/snackbarStore';

import { useProposalApi } from '../proposal-api';

export function useMergeProposal() {
  const { mergeProposal } = useProposalApi();
  const queryClient = useQueryClient();
  const { ALL_PROPOSALS, PROPOSAL, PROPOSAL_CHANGES } = QUERY_KEYS;

  return useMutation({
    mutationFn: ({ projectId, proposalId }: { projectId: string; proposalId: string }) => {
      return resolve(mergeProposal(projectId, proposalId));
    },
    onSuccess: (_data, variables) => {
      SNACKBAR_STORE.getState().showSnackbar('Proposal merged successfully', 'success', true);
      queryClient.invalidateQueries({ queryKey: [ALL_PROPOSALS, variables.projectId] });
      queryClient.invalidateQueries({ queryKey: [PROPOSAL, variables.projectId, variables.proposalId] });
      queryClient.invalidateQueries({ queryKey: [PROPOSAL_CHANGES, variables.projectId, variables.proposalId] });

      const { completedResultSets, clear } = GRID_STORE.getState();
      Object.entries(completedResultSets).forEach(([resultSetId, isCompleted]) => {
        if (isCompleted) {
          const { projectId } = getResultSetEntry(resultSetId);
          if (projectId === variables.projectId) {
            clear(resultSetId);
          }
        }
      });
    },
    onError: () => {
      SNACKBAR_STORE.getState().showSnackbar('Failed to merge proposal', 'error', true);
    }
  });
}
